import * as React from "react";
import AppBar from "@mui/material/AppBar";
import HomeIcon from "@mui/icons-material/Home";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import Avatar from "@mui/material/Avatar";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { AuthContext, BackendBaseUrl, ORANGE, ORANGE_HOVER, BLACK, BLACK_ELEV, PREMIUM_SHADOW } from "./global_varibles";
import AddIcon from "@mui/icons-material/Add";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { styled, alpha } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  TextField,
  Typography,
  Tooltip,
  Divider,
  Menu,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ScheduleDialog from "./shedule_order"; // Import the schedule dialog

interface AuthCtx {
  isAuthinticated: boolean;
  logout: () => void;
  user_data: { pick?: string };
}

interface SearchFormData {
  billNumber: string;
  name: string;
  phoneNumber: string;
  date: string;
  fromDate: string;
  toDate: string;
  status: "true" | "false";
}



const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: 10,
  border: `1px solid ${alpha(theme.palette.common.white, 0.08)}`,
  backgroundColor: alpha(theme.palette.common.white, 0.06),
  transition: "all .2s ease",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.1),
    borderColor: alpha(ORANGE, 0.4),
    boxShadow: `0 0 0 1px ${alpha(ORANGE, 0.2)}`,
  },
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: 340,
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.2, 1.2, 1.2, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create(["width", "background-color"]),
    "::placeholder": {
      color: alpha(theme.palette.common.white, 0.6),
      opacity: 1,
    },
  },
}));

function HeaderAppBar() {
  const { isAuthinticated, logout, user_data } = React.useContext(
    AuthContext as unknown as React.Context<AuthCtx>
  );
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [scheduleDialogOpen, setScheduleDialogOpen] = React.useState(false); // Add state for schedule dialog
  const [formData, setFormData] = React.useState<SearchFormData>({
    billNumber: "",
    name: "",
    phoneNumber: "",
    date: "",
    fromDate: "",
    toDate: "",
    status: "false",
  });

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  // account menu state
  const [accountMenuAnchor, setAccountMenuAnchor] = React.useState<null | HTMLElement>(null);
  const isAccountMenuOpen = Boolean(accountMenuAnchor);

  const toggleDrawer =
    (open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent): void => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setDrawerOpen(open);
    };

  // Close the drawer after performing an action
  const withClose = (fn: () => void) => () => {
    fn();
    setDrawerOpen(false);
  };

  const ReRouteToHomePage = () => navigate("/");
  const ReRouteToLoginPage = () => navigate("/login");
  const ReRouteToPrices = () => navigate("/prices");
  const ReRouteToOrder = () => {
    localStorage.removeItem("new_items");
    localStorage.removeItem("current_order_items");
    localStorage.removeItem("user_details");
    navigate("/order");
  };
  const ReRouteToNotifications = () => navigate("/notications");
  const ReRouteToSummary = () => navigate("/monthly-summary");
  const ReRouteToAdSummary = () => navigate("/monthly-ad-summary");
  const handleLogout = () => logout();
  // open/close account menu
  const handleAvatarClick = (e: React.MouseEvent<HTMLElement>) => setAccountMenuAnchor(e.currentTarget);
  const handleCloseAccountMenu = () => setAccountMenuAnchor(null);
  const handleLogoutFromMenu = () => {
    handleCloseAccountMenu();
    handleLogout();
  };

  // Add handler for schedule dialog
  const openScheduleDialog = () => setScheduleDialogOpen(true);
  const closeScheduleDialog = () => setScheduleDialogOpen(false);

  const openSearchDialog = () => setDialogOpen(true);
  const closeSearchDialog = () => setDialogOpen(false);

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target as { name: keyof SearchFormData; value: string };
    setFormData((prevData) => ({
      ...prevData,
      [name]: value as any,
    }));
  };

  const drawerContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: 260,
        backgroundColor: BLACK,
        color: "#f3f4f6",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1,
          py: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
          <img src="/mufty_care_logo.png" alt="MuftyCare" height={28} />
        </Box>
        <IconButton aria-label="Close menu" onClick={toggleDrawer(false)} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ borderColor: alpha("#fff", 0.08) }} />

      <List
        sx={{
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "inherit",
          color: "inherit",
          py: 0.5,
        }}
      >
        <ListItem sx={{ px: 1 }}>
          <ListItemButton
            onClick={withClose(ReRouteToHomePage)}
            sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
          >
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <HomeIcon sx={{ color: ORANGE }} />
              <ListItemText primary="Home" />
            </Box>
          </ListItemButton>
        </ListItem>

        <ListItem sx={{ px: 1 }}>
          <ListItemButton
            onClick={withClose(openSearchDialog)}
            sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
          >
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <SearchIcon sx={{ color: ORANGE }} />
              <ListItemText primary="Search Bill" />
            </Box>
          </ListItemButton>
        </ListItem>

        <ListItem sx={{ px: 1 }}>
          <ListItemButton
            onClick={withClose(ReRouteToPrices)}
            sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
          >
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <CurrencyRupeeIcon sx={{ color: ORANGE }} />
              <ListItemText primary="Prices" />
            </Box>
          </ListItemButton>
        </ListItem>

        {/* Add Book Now option in drawer for non-authenticated users */}
        {!isAuthinticated && (
          <ListItem sx={{ px: 1 }}>
            <ListItemButton
              onClick={withClose(openScheduleDialog)}
              sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
            >
              <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                <CalendarTodayIcon sx={{ color: ORANGE }} />
                <ListItemText primary="Book Now" />
              </Box>
            </ListItemButton>
          </ListItem>
        )}

        {!isAuthinticated ? (
          <ListItem sx={{ px: 1 }}>
            <ListItemButton
              onClick={withClose(ReRouteToLoginPage)}
              sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
            >
              <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                <Avatar sx={{ width: 28, height: 28 }} />
                <ListItemText primary="Login" />
              </Box>
            </ListItemButton>
          </ListItem>
        ) : (
          <Box>
            <ListItem sx={{ px: 1 }}>
              <ListItemButton
                onClick={withClose(ReRouteToOrder)}
                sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
              >
                <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                  <AddIcon sx={{ color: ORANGE }} />
                  <ListItemText primary="Create Order" />
                </Box>
              </ListItemButton>
            </ListItem>

            <ListItem sx={{ px: 1 }}>
              <ListItemButton
                onClick={withClose(ReRouteToNotifications)}
                sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
              >
                <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                  <NotificationsIcon sx={{ color: ORANGE }} />
                  <ListItemText primary="Notifications" />
                </Box>
              </ListItemButton>
            </ListItem>

            <ListItem sx={{ px: 1 }}>
              <ListItemButton
                onClick={withClose(ReRouteToSummary)}
                sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
              >
                <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                  <SummarizeIcon sx={{ color: ORANGE }} />
                  <ListItemText primary="Summary" />
                </Box>
              </ListItemButton>
            </ListItem>

            <ListItem sx={{ px: 1 }}>
              <ListItemButton
                onClick={withClose(ReRouteToAdSummary)}
                sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
              >
                <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                  <SummarizeIcon sx={{ color: ORANGE }} />
                  <ListItemText primary="Mo-Summ" />
                </Box>
              </ListItemButton>
            </ListItem>

            <ListItem sx={{ px: 1 }}>
              <ListItemButton
                onClick={withClose(handleLogout)}
                sx={{ borderRadius: 1, "&:hover": { backgroundColor: alpha(ORANGE, 0.12) } }}
              >
                <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
                  <Avatar
                    src={user_data?.pick}
                    sx={{ width: 28, height: 28, border: `2px solid ${ORANGE}` }}
                  />
                  <ListItemText primary="Logout" />
                </Box>
              </ListItemButton>
            </ListItem>
          </Box>
        )}
      </List>
      <Box sx={{ p: 2, borderTop: `1px solid ${alpha("#fff", 0.08)}`, backgroundColor: BLACK_ELEV }}>
        <Typography variant="caption" sx={{ color: alpha("#fff", 0.6) }}>
          © 2015 MuftyKare
        </Typography>
      </Box>
    </Box>
  );

  const handleSubmit = async (): Promise<void> => {
    if (formData.fromDate && formData.toDate && formData.fromDate > formData.toDate) {
      alert("From Date should be less than or equal to To Date.");
      return;
    }

    if (formData.toDate && !formData.fromDate) {
      alert("select from date");
      return;
    }

    const filteredData = Object.fromEntries(
      Object.entries(formData).filter(([, value]) => value !== "")
    ) as Partial<SearchFormData>;

    localStorage.removeItem("all_orders");
    try {
      const bkroute = `${BackendBaseUrl}search-bill`;
      const response = await fetch(bkroute, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(filteredData),
      });
      const response_data = (await response.json()) as {
        status?: string;
        orders_date?: unknown;
      };
      if (response.ok && response_data.status === "success") {
        localStorage.setItem("all_orders", JSON.stringify(response_data.orders_date));
        navigate("/show-orders");
      } else {
        console.error("Error submitting data");
      }
    } catch (error) {
      console.error("Error:", error);
    }

    setFormData({
      billNumber: "",
      name: "",
      phoneNumber: "",
      date: "",
      fromDate: "",
      toDate: "",
      status: "false",
    });
    closeSearchDialog();
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          background: `linear-gradient(180deg, ${BLACK} 0%, ${BLACK_ELEV} 100%)`,
          borderBottom: `1px solid ${alpha("#fff", 0.08)}`,
        }}
        elevation={0}
      >
        <Toolbar
          sx={{
            display: "flex",
            gap: 2,
            pl: { xs: isAuthinticated ? 1 : 0, sm: 2 }, // small left inset when logged in
            pr: { xs: 0, sm: 2 },
          }}
        >
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              // no gap between toggle and logo on xs when authenticated; keep desktop spacing
              gap: { xs: isAuthinticated ? 0 : 1.5, sm: 2 } 
            }}
          >
            {(isAuthinticated || window.innerWidth >= 600) && (
              <IconButton
                edge="start"
                size="large"
                color="inherit"
                onClick={() => setDrawerOpen(true)}
                aria-label="Open menu"
                sx={{
                  display: { xs: isAuthinticated ? 'flex' : 'none', sm: 'flex' },
                  mr: 0, // ensure no extra margin
                  "&:hover": { color: ORANGE },
                  transition: "color .2s ease",
                }}
              >
                <MenuIcon />
              </IconButton>
            )}

            <Button
              onClick={ReRouteToHomePage}
              sx={{
                px: { xs: 0, sm: 1 }, // keep logo flush on mobile
                ml: 0,
                minWidth: 0,
                color: "#fff",
                "&:hover": { opacity: 0.9 },
              }}
            >
              <img
                src="/mufty_care_logo.png"
                alt="MuftyCare"
                height="36"
                style={{ maxHeight: "36px", width: "auto" }}
              />
            </Button>
          </Box>

          {/* Hide search on mobile */}
          <Box sx={{ 
            flex: 1, 
            display: { xs: 'none', sm: 'flex' }, 
            justifyContent: "center" 
          }}>
            <Search onClick={openSearchDialog} className="cursor-pointer">
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                readOnly
                placeholder="Search bill by number, name, phone..."
                inputProps={{ "aria-label": "search" }}
              />
            </Search>
          </Box>

          {/* Right-aligned icons */}
          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 1,
            ml: 'auto',
            pr: { xs: 0, sm: 0 } // no right padding on mobile
          }}>
            {isAuthinticated ? (
              <>
                {/* Show Create Order on mobile, hide on desktop */}
                <Tooltip title="Create Order">
                  <IconButton
                    aria-label="Create Order"
                    onClick={ReRouteToOrder}
                    sx={{
                      display: { xs: 'flex', sm: 'none' }, // Show on mobile, hide on desktop
                      color: ORANGE,
                      "&:hover": { color: ORANGE_HOVER, backgroundColor: alpha(ORANGE, 0.12) },
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>

                {/* Show Notification on desktop only */}
                <Tooltip title="Notifications">
                  <IconButton
                    aria-label="Notifications"
                    onClick={ReRouteToNotifications}
                    sx={{
                      display: { xs: 'none', sm: 'flex' }, // Hide on mobile, show on desktop
                      color: "#fff",
                      "&:hover": { color: ORANGE, backgroundColor: alpha(ORANGE, 0.12) },
                    }}
                  >
                    <NotificationsIcon />
                  </IconButton>
                </Tooltip>

                {/* Keep profile icon visible on all screens */}
                <Tooltip title="Account">
                  <IconButton
                    aria-label="Account"
                    onClick={handleAvatarClick}
                    aria-controls={isAccountMenuOpen ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={isAccountMenuOpen ? "true" : undefined}
                    sx={{
                      p: 0.3,
                      border: `2px solid ${alpha(ORANGE, 0.6)}`,
                      "&:hover": { borderColor: ORANGE },
                      borderRadius: "50%",
                    }}
                  >
                    <Avatar
                      src={user_data?.pick}
                      sx={{ width: 32, height: 32, backgroundColor: alpha("#fff", 0.1) }}
                    />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <>
                {/* Book Now Button for non-authenticated users */}
                <Button
                  onClick={openScheduleDialog}
                  startIcon={<CalendarTodayIcon sx={{ fontSize: '18px !important' }} />}
                  sx={{
                    mr: 0, // flush to the right edge
                    background: `linear-gradient(135deg, ${ORANGE} 0%, ${ORANGE_HOVER} 100%)`,
                    color: "#0b0b0b",
                    fontWeight: 700,
                    textTransform: "none",
                    px: { xs: 2, sm: 3 },
                    py: 1,
                    fontSize: { xs: '0.85rem', sm: '0.9rem' },
                    borderRadius: 2,
                    boxShadow: `0 4px 14px ${alpha(ORANGE, 0.3)}`,
                    transition: "all 0.3s ease",
                    "&:hover": { 
                      background: `linear-gradient(135deg, ${ORANGE_HOVER} 0%, #d97706 100%)`,
                      transform: "translateY(-1px)",
                      boxShadow: `0 6px 20px ${alpha(ORANGE, 0.4)}`
                    },
                    "& .MuiButton-startIcon": {
                      marginRight: { xs: 0.5, sm: 1 },
                      marginLeft: 0
                    }
                  }}
                >
                  <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                    Book Now
                  </Box>
                  <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    Book Now
                  </Box>
                </Button>
              </>
            )}
          </Box>
        </Toolbar>

        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          PaperProps={{
            sx: {
              backgroundColor: BLACK,
              color: "#f3f4f6",
              width: 280,
              borderRight: `1px solid ${alpha("#fff", 0.08)}`,
            },
          }}
        >
          {drawerContent}
        </Drawer>
      </AppBar>

      {/* Account Menu for authenticated users */}
      <Menu
        id="account-menu"
        anchorEl={accountMenuAnchor}
        open={isAccountMenuOpen}
        onClose={handleCloseAccountMenu}
        onClick={handleCloseAccountMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            backgroundColor: BLACK_ELEV,
            color: '#fff',
            border: `1px solid ${alpha('#fff', 0.1)}`,
            borderRadius: 3,
            mt: 1.5,
            minWidth: 200,
            boxShadow: PREMIUM_SHADOW,
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: BLACK_ELEV,
              border: `1px solid ${alpha('#fff', 0.1)}`,
              borderBottom: 'none',
              borderRight: 'none',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem 
          onClick={handleLogoutFromMenu}
          sx={{
            py: 1.5,
            px: 2,
            '&:hover': {
              backgroundColor: alpha(ORANGE, 0.12),
              color: ORANGE
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar
              src={user_data?.pick}
              sx={{ width: 28, height: 28, border: `2px solid ${ORANGE}` }}
            />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Logout
            </Typography>
          </Box>
        </MenuItem>
      </Menu>

      {/* Schedule Dialog */}
      <ScheduleDialog 
        open={scheduleDialogOpen}
        handleClose={closeScheduleDialog}
      />

      {/* Search Dialog - existing code remains the same */}
      <Dialog
        open={dialogOpen}
        onClose={closeSearchDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: BLACK_ELEV,
            color: "#fff",
            borderRadius: { xs: 0, sm: 3 },
            border: `1px solid ${alpha("#fff", 0.1)}`,
            boxShadow: PREMIUM_SHADOW,
            margin: { xs: 0, sm: 2 },
            maxHeight: { xs: '100vh', sm: '90vh' },
            width: { xs: '100%', sm: 'auto' },
          },
        }}
      >
        <DialogTitle 
          sx={{ 
            fontWeight: 700,
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            pb: 2,
            pt: { xs: 2, sm: 3 },
            px: { xs: 2, sm: 3 },
            borderBottom: `1px solid ${alpha("#fff", 0.08)}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'sticky',
            top: 0,
            backgroundColor: BLACK_ELEV,
            zIndex: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <SearchIcon sx={{ color: ORANGE, fontSize: { xs: 24, sm: 28 } }} />
            <span>Search Bill</span>
          </Box>
          <IconButton 
            onClick={closeSearchDialog}
            sx={{ 
              color: alpha('#fff', 0.7),
              '&:hover': { 
                color: '#fff',
                backgroundColor: alpha('#fff', 0.08) 
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent 
          sx={{ 
            pt: 3, 
            pb: 2, 
            px: { xs: 2, sm: 3 },
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: alpha('#fff', 0.05),
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: alpha(ORANGE, 0.3),
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: alpha(ORANGE, 0.5),
              }
            },
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>
            <TextField
              label="Bill Number"
              type="number"
              fullWidth
              name="billNumber"
              value={formData.billNumber}
              onChange={handleInputChange}
              variant="outlined"
              placeholder="Enter bill number"
              InputLabelProps={{ 
                shrink: true,
                sx: { 
                  color: alpha('#fff', 0.7), 
                  fontWeight: 500,
                  fontSize: { xs: '0.9rem', sm: '1rem' }
                }
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: alpha('#fff', 0.04),
                  borderRadius: 2,
                  "& fieldset": { 
                    borderColor: alpha("#fff", 0.12),
                    transition: 'all 0.2s ease'
                  },
                  "&:hover fieldset": { 
                    borderColor: alpha(ORANGE, 0.5),
                  },
                  "&.Mui-focused fieldset": { 
                    borderColor: ORANGE,
                    borderWidth: 2
                  },
                  "& input": {
                    color: '#fff',
                    fontSize: { xs: '0.9rem', sm: '0.95rem' },
                    padding: { xs: '12px 14px', sm: '16.5px 14px' }
                  }
                },
              }}
            />

            {isAuthinticated && (
              <>
                <TextField
                  label="Customer Name"
                  type="text"
                  fullWidth
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  variant="outlined"
                  placeholder="Enter customer name"
                  InputLabelProps={{ 
                    shrink: true,
                    sx: { 
                      color: alpha('#fff', 0.7), 
                      fontWeight: 500,
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: alpha('#fff', 0.04),
                      borderRadius: 2,
                      "& fieldset": { 
                        borderColor: alpha("#fff", 0.12),
                        transition: 'all 0.2s ease'
                      },
                      "&:hover fieldset": { 
                        borderColor: alpha(ORANGE, 0.5),
                      },
                      "&.Mui-focused fieldset": { 
                        borderColor: ORANGE,
                        borderWidth: 2
                      },
                      "& input": {
                        color: '#fff',
                        fontSize: { xs: '0.9rem', sm: '0.95rem' },
                        padding: { xs: '12px 14px', sm: '16.5px 14px' }
                      }
                    },
                  }}
                />

                <TextField
                  label="Phone Number"
                  type="number"
                  fullWidth
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  variant="outlined"
                  placeholder="Enter phone number"
                  InputLabelProps={{ 
                    shrink: true,
                    sx: { 
                      color: alpha('#fff', 0.7), 
                      fontWeight: 500,
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: alpha('#fff', 0.04),
                      borderRadius: 2,
                      "& fieldset": { 
                        borderColor: alpha("#fff", 0.12),
                        transition: 'all 0.2s ease'
                      },
                      "&:hover fieldset": { 
                        borderColor: alpha(ORANGE, 0.5),
                      },
                      "&.Mui-focused fieldset": { 
                        borderColor: ORANGE,
                        borderWidth: 2
                      },
                      "& input": {
                        color: '#fff',
                        fontSize: { xs: '0.9rem', sm: '0.95rem' },
                        padding: { xs: '12px 14px', sm: '16.5px 14px' }
                      }
                    },
                  }}
                />

                <TextField
                  label="Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ 
                    shrink: true,
                    sx: { 
                      color: alpha('#fff', 0.7), 
                      fontWeight: 500,
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }
                  }}
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: alpha('#fff', 0.04),
                      borderRadius: 2,
                      "& fieldset": { 
                        borderColor: alpha("#fff", 0.12),
                        transition: 'all 0.2s ease'
                      },
                      "&:hover fieldset": { 
                        borderColor: alpha(ORANGE, 0.5),
                      },
                      "&.Mui-focused fieldset": { 
                        borderColor: ORANGE,
                        borderWidth: 2
                      },
                      "& input": {
                        color: '#fff',
                        fontSize: { xs: '0.9rem', sm: '0.95rem' },
                        padding: { xs: '12px 14px', sm: '16.5px 14px' },
                        '&::-webkit-calendar-picker-indicator': {
                          filter: 'invert(1)',
                          cursor: 'pointer'
                        }
                      }
                    },
                  }}
                />

                <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                  <TextField
                    label="From Date"
                    type="date"
                    fullWidth
                    InputLabelProps={{ 
                      shrink: true,
                      sx: { 
                        color: alpha('#fff', 0.7), 
                        fontWeight: 500,
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                      }
                    }}
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleInputChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: alpha('#fff', 0.04),
                        borderRadius: 2,
                        "& fieldset": { 
                          borderColor: alpha("#fff", 0.12),
                          transition: 'all 0.2s ease'
                        },
                        "&:hover fieldset": { 
                          borderColor: alpha(ORANGE, 0.5),
                        },
                        "&.Mui-focused fieldset": { 
                          borderColor: ORANGE,
                          borderWidth: 2
                        },
                        "& input": {
                          color: '#fff',
                          fontSize: { xs: '0.9rem', sm: '0.95rem' },
                          padding: { xs: '12px 14px', sm: '16.5px 14px' },
                          '&::-webkit-calendar-picker-indicator': {
                            filter: 'invert(1)',
                            cursor: 'pointer'
                          }
                        }
                      },
                    }}
                  />
                  <TextField
                    label="To Date"
                    type="date"
                    fullWidth
                    InputLabelProps={{ 
                      shrink: true,
                      sx: { 
                        color: alpha('#fff', 0.7), 
                        fontWeight: 500,
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                      }
                    }}
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleInputChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: alpha('#fff', 0.04),
                        borderRadius: 2,
                        "& fieldset": { 
                          borderColor: alpha("#fff", 0.12),
                          transition: 'all 0.2s ease'
                        },
                        "&:hover fieldset": { 
                          borderColor: alpha(ORANGE, 0.5),
                        },
                        "&.Mui-focused fieldset": { 
                          borderColor: ORANGE,
                          borderWidth: 2
                        },
                        "& input": {
                          color: '#fff',
                          fontSize: { xs: '0.9rem', sm: '0.95rem' },
                          padding: { xs: '12px 14px', sm: '16.5px 14px' },
                          '&::-webkit-calendar-picker-indicator': {
                            filter: 'invert(1)',
                            cursor: 'pointer'
                          }
                        }
                      },
                    }}
                  />
                </Box>

                <TextField
                  label="Delivery Status"
                  select
                  fullWidth
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  InputLabelProps={{ 
                    shrink: true,
                    sx: { 
                      color: alpha('#fff', 0.7), 
                      fontWeight: 500,
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: alpha('#fff', 0.04),
                      borderRadius: 2,
                      "& fieldset": { 
                        borderColor: alpha("#fff", 0.12),
                        transition: 'all 0.2s ease'
                      },
                      "&:hover fieldset": { 
                        borderColor: alpha(ORANGE, 0.5),
                      },
                      "&.Mui-focused fieldset": { 
                        borderColor: ORANGE,
                        borderWidth: 2
                      },
                      "& .MuiSelect-select": {
                        color: '#fff',
                        fontSize: { xs: '0.9rem', sm: '0.95rem' },
                        padding: { xs: '12px 14px', sm: '16.5px 14px' }
                      },
                      "& .MuiSvgIcon-root": {
                        color: alpha('#fff', 0.7)
                      }
                    },
                  }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        sx: {
                          backgroundColor: BLACK,
                          border: `1px solid ${alpha("#fff", 0.12)}`,
                          borderRadius: 2,
                          mt: 0.5,
                          "& .MuiMenuItem-root": {
                            color: '#fff',
                            fontSize: { xs: '0.9rem', sm: '0.95rem' },
                            "&:hover": {
                              backgroundColor: alpha(ORANGE, 0.12),
                            },
                            "&.Mui-selected": {
                              backgroundColor: alpha(ORANGE, 0.2),
                              "&:hover": {
                                backgroundColor: alpha(ORANGE, 0.25),
                              }
                            }
                          }
                        }
                      }
                    }
                  }}
                >
                  <MenuItem value="true">Delivered</MenuItem>
                  <MenuItem value="false">Not Delivered</MenuItem>
                </TextField>
              </>
            )}

            {!isAuthinticated && (
              <Box 
                sx={{ 
                  p: { xs: 2, sm: 2.5 },
                  backgroundColor: alpha(ORANGE, 0.08),
                  borderRadius: 2,
                  border: `1px solid ${alpha(ORANGE, 0.2)}`,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5
                }}
              >
                <Box 
                  sx={{ 
                    width: { xs: 36, sm: 40 },
                    height: { xs: 36, sm: 40 },
                    borderRadius: '50%',
                    backgroundColor: alpha(ORANGE, 0.15),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}
                >
                  <SearchIcon sx={{ color: ORANGE, fontSize: { xs: 18, sm: 20 } }} />
                </Box>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: alpha("#fff", 0.85),
                    lineHeight: 1.6,
                    fontSize: { xs: '0.85rem', sm: '0.9rem' }
                  }}
                >
                  Login to access advanced search filters including name, phone, date range, and delivery status.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions 
          sx={{ 
            px: { xs: 2, sm: 3 },
            pb: { xs: 2, sm: 3 },
            pt: 2,
            gap: 1.5,
            position: 'sticky',
            bottom: 0,
            backgroundColor: BLACK_ELEV,
            borderTop: `1px solid ${alpha("#fff", 0.08)}`,
          }}
        >
          <Button
            onClick={closeSearchDialog}
            variant="outlined"
            fullWidth
            sx={{ 
              color: alpha("#fff", 0.85),
              textTransform: "none",
              fontWeight: 600,
              py: { xs: 1, sm: 1.2 },
              borderRadius: 2,
              borderColor: alpha('#fff', 0.2),
              fontSize: { xs: '0.9rem', sm: '0.95rem' },
              '&:hover': {
                borderColor: alpha('#fff', 0.4),
                backgroundColor: alpha('#fff', 0.05)
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            fullWidth
            sx={{
              backgroundColor: ORANGE,
              color: "#0b0b0b",
              fontWeight: 700,
              textTransform: "none",
              py: { xs: 1, sm: 1.2 },
              borderRadius: 2,
              fontSize: { xs: '0.9rem', sm: '0.95rem' },
              boxShadow: `0 4px 14px 0 ${alpha(ORANGE, 0.4)}`,
              "&:hover": { 
                backgroundColor: ORANGE_HOVER,
                boxShadow: `0 6px 20px 0 ${alpha(ORANGE, 0.5)}`,
              },
            }}
          >
            Search
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default HeaderAppBar;

